import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTelegram } from "../../../hooks/useTelegram";
import { useDispatch, useSelector } from "react-redux";
import { PATH_THANKYOU, PATH_CHECKOUT } from "../../../constants/Paths";
import { replaceCart } from "../../kit/Redux/Actions";
import TelegramScreen from "../../kit/Screen/TelegramScreen";
import PaymentCard from "../../kit/PaymentCard/PaymentCard";
import TelegramText from "../../kit/Text/TelegramText";
import TelegramMiniMultiConfirmationForm from "../../kit/MiniMultiConfirmationForm/TelegramMiniMultiConfirmationForm";
import {
  proceedOrderToServer,
  validateAvailableInventory,
} from "../../../logic/server/OrderFunction";
import { removeFullItemFromCart } from "../../kit/Redux/Actions";
import TelegramHeader from "../../kit/Header/TelegramHeader";
import PaymentForm from "../../kit/PaymentForm/PaymentForm";
import { buildOrderPayloadV2 } from "../../../logic/server/PayloadBuilder";
import PromotionCard from "../../kit/PromotionCard/PromotionCard";
import PaymentHandler from "../../kit/PaymentHandler/PaymentHandler";
import { submitNewOrder } from "../../utils/submit-new-order";
import Divider from "../../kit/Divider/Divider";
import { useModal } from "../../providers/ModalProvider";
import StoreIndicator from "../../kit/StoreIndicator/StoreIndicator";
import { compareOrderItems } from "../../utils/order-comparison";

// Define the function outside of your component
function isDeliveryWaiverPromotionApplied(promotions) {
  // Assuming `promotions` is an array of the promotions applied to the order
  for (let i = 0; i < promotions.length; i++) {
    if (promotions[i].chargedescription.includes("FREE DELIVERY")) {
      return true;
    }
  }
  return false;
}

/**
 * /messages endpoint is used to send messages to the bot server using a REST API.
 * The bot will receive the message and echo it in the chat.
 *
 * @see sendMessageToServer
 */
const SendMessageToServerCall = ({ pageTitle }) => {
  const { webApp, user } = useTelegram();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { triggerModal } = useModal();

  const cartItems = useSelector((state) => state.cartItems.cartItems);
  const existingOrderCartItems = useSelector(
    (state) => state.existingOrderCartItems
  );

  const sessionToken = useSelector((state) => state.sessionToken);
  const agent = useSelector((state) => state.agent);
  const cartBaseCost = cartItems.reduce((a, c) => a + c.price * c.quantity, 0);
  const requiredDeliveryCharges = useSelector(
    (state) => state.requiredDeliveryCharges
  );
  const requiredSurchargeCharges = useSelector(
    (state) => state.requiredSurchargeCharges
  );
  const requiredExclusivePromotionCharges = useSelector(
    (state) => state.requiredExclusivePromotionCharges
  );

  // const requiredConcurrentPromotionCharges = useSelector(
  //   (state) => state.requiredConcurrentPromotionCharges
  // );
  const baseManualPricingEnabled = useSelector(
    (state) => state.baseManualPricing
  );

  const agentPolicyManualPricingEnabled = useSelector(
    (state) => state.agentPolicyManualPricing
  );

  const routeDetails = useSelector((state) => state.routeDetails);
  const selectedStore = useSelector((state) => state.selectedStore);

  // Calculate order changes for amendment flow
  // React.useEffect(() => {
  //   alert(`[SendFormMessageToServerCall] Page loaded:\nExisting order items: ${existingOrderCartItems?.length || 0}\nCart items: ${cartItems?.length || 0}`);
  // }, []);

  const orderChanges = existingOrderCartItems
    ? compareOrderItems(existingOrderCartItems, cartItems)
    : {
        additions: cartItems,
        increases: [],
        decreases: [],
        removals: [],
        unchanged: [],
      };

  const deliveryCost =
    requiredDeliveryCharges.length > 0
      ? parseFloat(requiredDeliveryCharges[0].chargeamount)
      : 0; // Default to 0 if existingOrderCartItems is null or requiredDeliveryCharges is empty
  const surchargeCost =
    requiredSurchargeCharges.length > 0
      ? parseFloat(requiredSurchargeCharges[0].chargeamount)
      : 0; // Default to 0 if existingOrderCartItems is null or requiredSurchargeCharges is empty

  // Calculate promotionCost by summing up chargeamount values from requiredPromotionCharges
  const exclusivePromotionCost = requiredExclusivePromotionCharges.reduce(
    (total, charge) => {
      return total + parseFloat(charge.chargeamount);
    },
    0
  ); // Start with total 0

  const agentId = agent.id; // [0] - Id, [1] Code

  // const [buttonDisabled, setButtonDisabled] = useState("false");
  const [buttonText, setButtonText] = useState();
  const [isOrderSectionExpanded, setIsOrderSectionExpanded] = useState(true);
  const [isDetailsSectionExpanded, setIsDetailsSectionExpanded] =
    useState(true);
  const [paymentCost, setPaymentCost] = useState(0);
  const [reduceCost, setReduceCost] = useState(0);
  const [updatedCartItems, setUpdatedCartItems] = useState([]);
  const [cartItemsToRemove, setCartItemsToRemove] = useState([]);

  // Popup for Partial Order Fulfilment
  const [showPartialOrderFulfilmentPopup, setShowPartialOrderFulfilmentPopup] =
    useState(false); // State variable for controlling the visibility of the confirm popup
  const [isPartialOrderFulfilmentNeeded, setIsPartialOrderFulfilmentNeeded] =
    useState(false); // State variable for controlling the visibility of the confirm popup

  // Popup for Manual Pricing
  const [showManualPricingPopup, setShowManualPricingPopup] = useState(false); // State variable for controlling the visibility of the confirm popup
  const [isManualPricingNeeded, setIsManualPricingNeeded] = useState(false); // State variable for controlling the visibility of the confirm popup
  const [manualPaymentCost, setManualPaymentCost] = useState(0);
  const [isDeliveryWaived, setIsDeliveryWaived] = useState(false);

  const storeTotalCost =
    cartBaseCost +
    deliveryCost +
    surchargeCost +
    exclusivePromotionCost -
    //concurrentPromotionCost -
    reduceCost;

  // This id will be used by our backend to send messages to the chat with the user
  let queryId = webApp.initDataUnsafe?.query_id;

  const onMainClick = async ({ name, phone, address, timeSlot, comments }) => {
    try {
      // Enabling/disabling the button
      webApp.BackButton.hide();
      webApp.MainButton.disable();
      webApp.MainButton.showProgress(false);

      // Calculate final costs
      const finalBaseCost = manualPaymentCost
        ? parseFloat(manualPaymentCost)
        : parseFloat(cartBaseCost);
      const finalDeliveryCost = parseFloat(deliveryCost);
      const finalSurchargeCost = parseFloat(surchargeCost);
      const finalDiscountAmount = parseFloat(exclusivePromotionCost);

      if (!queryId) {
        throw new Error("Please contact the administrator.");
      }

      const utils = { webApp, sessionToken, navigate, dispatch };

      const userDetails = {
        userId: user?.id,
        userName: user?.username,
        agentId,
        routeDetails,
        customerName: name,
        customerContact: phone,
        customerAddress: address,
        timeSlot,
        customerComments: comments,
      };

      const orderCosts = {
        isDeliveryWaived,
        discountAmount: finalDiscountAmount,
        deliveryCost: finalDeliveryCost,
        surchargeCost: finalSurchargeCost,
        paymentCost: finalBaseCost,
        storeTotalCost: storeTotalCost,
        charges: {
          deliveryCharges: requiredDeliveryCharges,
          surchargeCharges: requiredSurchargeCharges,
          promotionCharges: requiredExclusivePromotionCharges,
        },
      };

      if (!isPartialOrderFulfilmentNeeded) {
        const { isAvailable, updatedCartItems, itemsToRemove } =
          await validateAvailableInventory(
            sessionToken,
            cartItems,
            null,
            selectedStore
          );

        if (!isAvailable) {
          // Build item descriptions for alert
          const removedDescriptions = itemsToRemove.map(item => {
            const parts = [item.type, item.brand, item.category, item.title].filter(Boolean);
            return parts.join(" - ");
          });

          // Update cart: keep only available items with adjusted quantities
          dispatch(replaceCart(updatedCartItems.filter(item => item.quantity > 0)));

          // Update product list availableQty
          dispatch({
            type: "UPDATE_PRODUCT_AVAILABILITY",
            payload: itemsToRemove.map(item => ({
              id: item.id,
              availableQty: 0,
            })),
          });

          webApp.MainButton.hideProgress(true);

          alert(
            `Some items are no longer available.\n\n` +
            removedDescriptions.join("\n") +
            `\n\nYour cart has been updated. Redirecting to cart...`
          );

          navigate(PATH_CHECKOUT, { replace: true });
          return;
        }

        // Let's check whether we allow manual updating of total cost
        if (baseManualPricingEnabled || agentPolicyManualPricingEnabled) {
          if (!isManualPricingNeeded) {
            webApp.MainButton.hideProgress(true);
            // setButtonText(`Manual Pay`);
            setManualPaymentCost(parseFloat(paymentCost.toFixed(2)));
            // Show the confirm popup
            setIsManualPricingNeeded(true);
            setShowManualPricingPopup(true);

            return;
          }

          if (finalBaseCost < 0) {
            webApp.MainButton.hideProgress(true);
            alert("Please input a valid amount.");
            return;
          }

          if (agentPolicyManualPricingEnabled) {
            if (finalBaseCost < storeTotalCost) {
              alert("Amount cannot be lower than store cost.");
              webApp.MainButton.hideProgress(true);
              return;
            }
          }
        }

        submitNewOrder(
          utils,
          userDetails,
          orderCosts,
          cartItems,
          selectedStore
        );

        // proceedOrder(
        //   sessionToken,
        //   name,
        //   phone,
        //   address,
        //   routeDetails,
        //   timeSlot,
        //   cartItems,
        //   comments,
        //   finalDiscountAmount,
        //   finalDeliveryCost,
        //   finalSurchargeCost,
        //   finalBaseCost,
        //   storeTotalCost, // 6/Jun/2024 VE  - Total Cost From Front End Store
        //   agentId,
        //   user
        // );
      } else {
        // Let's check whether we allow manual updating of total cost
        if (baseManualPricingEnabled || agentPolicyManualPricingEnabled) {
          if (!isManualPricingNeeded) {
            webApp.MainButton.hideProgress(true);
            // setButtonText(`Manual Pay`);
            setManualPaymentCost(parseFloat(paymentCost.toFixed(2)));
            // Show the confirm popup
            setIsManualPricingNeeded(true);
            setShowManualPricingPopup(true);
            return;
          }

          if (finalBaseCost < 0) {
            alert("Please input a valid amount.");
            webApp.MainButton.hideProgress(true);
            return;
          }

          if (agentPolicyManualPricingEnabled) {
            if (finalBaseCost < storeTotalCost) {
              alert("Amount cannot be lower than store cost.");
              webApp.MainButton.hideProgress(true);
              return;
            }
          }
        }
        // Since it is after confirmation popup, it is likely there are items in the cart to be removed
        // So let's remove it first before we move on

        alert(
          "Remove the items in the cart items that do not have available quantity"
        );
        updatedCartItems.forEach((item) => {
          if (item.quantity === 0) {
            dispatch(removeFullItemFromCart(item));
          }
        });

        const updatedCartItemsRemoveEmpty = updatedCartItems.filter(
          (item) => item.quantity > 0
        );

        setUpdatedCartItems(updatedCartItemsRemoveEmpty);

        submitNewOrder(
          utils,
          userDetails,
          orderCosts,
          updatedCartItemsRemoveEmpty,
          selectedStore
        );

        // proceedOrder(
        //   sessionToken,
        //   name,
        //   phone,
        //   address,
        //   routeDetails,
        //   timeSlot,
        //   updatedCartItemsRemoveEmpty,
        //   comments,
        //   finalDiscountAmount,
        //   finalDeliveryCost,
        //   finalSurchargeCost,
        //   finalBaseCost,
        //   storeTotalCost, // 6/Jun/2024 VE  - Total Cost From Front End Store
        //   agentId,
        //   user
        // );
      }
    } catch (error) {
      // Handle the error gracefully, e.g., show an error message to the user
      webApp.BackButton.show();

      console.error("Error sending message:", error);
      alert(`${error}`);
    }
  };

  // 31/Mar/2024 VE - Moved proceedOrder to OrderFunction
  // sessionToken, name, phone, address, timeSlot, cart, comments, deliveryCost, surchargeCost, paymentCost, agentId, user
  const proceedOrder = async (
    sessionToken,
    name,
    phone,
    address,
    routeDetails,
    timeSlot,
    cart,
    comments,
    discountAmount,
    deliveryCost,
    surchargeCost,
    paymentCost,
    storeTotalCost,
    agentId,
    user
  ) => {
    try {
      const userDetails = {
        userId: user?.id,
        userName: user?.username,
      };

      const postalCodeDetails = {
        address: address,
        postalCodeDescr: routeDetails.postalcodedescr,
      };

      const featureFlags = {
        isDeliveryWaived,
      };

      const orderCosts = {
        discountAmount: discountAmount,
        deliveryCost: deliveryCost,
        surchargeCost: surchargeCost,
        baseCost: paymentCost,
        storeTotalCost,
      };

      const customerDetails = {
        orderName: name,
        orderPhone: phone,
        orderAddress: address,
        comments: comments,
      };

      const orderSummary = buildOrderPayloadV2(
        userDetails,
        customerDetails,
        postalCodeDetails,
        featureFlags,
        cart,
        timeSlot,
        orderCosts,
        routeDetails,
        agentId
      );

      const result = await proceedOrderToServer(
        sessionToken,
        orderSummary,
        selectedStore
      );

      // Only navigate to success page if order was actually created successfully
      if (result && result.success && result.order) {
        navigate(PATH_THANKYOU, {
          replace: true,
        });
      } else {
        // Handle failed order creation
        webApp.MainButton.hideProgress(true);
        webApp.BackButton.show();

        const errorMessage =
          result?.error || "Order creation failed. Please try again.";
        alert(`Order Failed: ${errorMessage}`);
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Error sending message:", error);
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();
      // Handle the error gracefully, e.g., show an error message to the user
      alert(`${error}`);
    }
  };

  useEffect(() => {
    // Check if a promotion applies and waives the delivery cost
    if (
      requiredExclusivePromotionCharges?.length > 0 &&
      isDeliveryWaiverPromotionApplied(requiredExclusivePromotionCharges)
    ) {
      setIsDeliveryWaived(true);
    }
    let payCost =
      cartBaseCost +
      deliveryCost +
      surchargeCost +
      exclusivePromotionCost -
      //concurrentPromotionCost -
      reduceCost;

    setButtonText(`Pay $${payCost}`);
    if (manualPaymentCost) {
      payCost = manualPaymentCost;
      setButtonText(`Admin Pay $${payCost}`);
    } else {
      // setManualPaymentCost(payCost);
    }

    setPaymentCost(payCost);
  }, [
    cartBaseCost,
    deliveryCost,
    surchargeCost,
    exclusivePromotionCost,
    //concurrentPromotionCost,
    paymentCost,
    reduceCost,
    cartItemsToRemove,
    manualPaymentCost,
    requiredExclusivePromotionCharges,
  ]);

  const onChangeTotalCost = (newValue) => {
    setManualPaymentCost(newValue);
  };

  return (
    <TelegramScreen>
      <StoreIndicator />
      <TelegramHeader>
        <TelegramText className={"telegramTitle"}>{pageTitle}</TelegramText>
      </TelegramHeader>
      <div className="payment__cards__container">
        {/* Sticky Total at top */}
        <div className="payment__cost__container payment__cost__container--sticky-top">
          <h4>Total</h4>
          <span>${paymentCost}</span>
        </div>

        <div className="payment__cart__container">
          <div
            className="payment__section-title payment__section-title--collapsible"
            onClick={() => setIsOrderSectionExpanded(!isOrderSectionExpanded)}
          >
            Order Summary
            <span
              className={`payment__section-toggle ${
                isOrderSectionExpanded ? "expanded" : ""
              }`}
            >
              {isOrderSectionExpanded ? "▼" : "▶"}
            </span>
          </div>
          {isOrderSectionExpanded && (
            <div className="payment__order__summary">
              {/* <div className="payment__section-title">Order Items</div> */}
              <div className="payment__cart__items">
                {/* Show new items */}
                {orderChanges.additions.map((item) => {
                  return <PaymentCard food={item} key={`add-${item.id}`} />;
                })}

                {/* Show quantity increases */}
                {orderChanges.increases.map((item) => {
                  return <PaymentCard food={item} key={`inc-${item.id}`} />;
                })}

                {/* Show quantity decreases */}
                {orderChanges.decreases.map((item) => {
                  return <PaymentCard food={item} key={`dec-${item.id}`} />;
                })}

                {/* Show unchanged items */}
                {orderChanges.unchanged.map((item) => {
                  return <PaymentCard food={item} key={`same-${item.id}`} />;
                })}

                {/* Show removed items with negative pricing */}
                {orderChanges.removals.map((item) => {
                  return (
                    <PaymentCard
                      food={item}
                      isNegative={true}
                      key={`rem-${item.id}`}
                    />
                  );
                })}
              </div>

              <div className="payment__charges__container">
                {/* <div className="payment__section-title">Charges</div> */}
                <div className="payment__delivery__container">
                  Delivery
                  <span>${deliveryCost.toFixed(2)}</span>
                </div>
                <div className="payment__surcharge__container">
                  Surcharge
                  <span>${surchargeCost.toFixed(2)}</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {showPartialOrderFulfilmentPopup && (
          <div className="confirm__popup">
            {/* <p>Some items in your cart are unavailable. The following items will
              be removed from your cart:</p> */}
            <div className="unavailable__cart__container">
              {cartItemsToRemove.map((item) => {
                return (
                  <PaymentCard food={item} key={item.id} isNegative={true} />
                );
              })}
            </div>
            {/* <p>Original Cart Items:</p>
            <div className="payment__cart__container">
              {updatedCartItems.map((item) => {
                return <PaymentCard food={item} key={item.id} />;
              })}
            </div> */}

            {/* <button onClick={handleConfirm}>Confirm</button> */}
            {/* <button onClick={handleCancel}>Cancel</button> */}
          </div>
        )}
        {requiredExclusivePromotionCharges.length > 0 ? (
          <div className="promotion__cost__container">
            <div className="payment__section-title">Promotions</div>
            {requiredExclusivePromotionCharges.map((promotion) => {
              return <PromotionCard promotion={promotion} />;
            })}
          </div>
        ) : (
          ""
        )}

        {/* <Divider /> */}
        <div className="payment__cart__container">
          <div
            className="payment__section-title payment__section-title--collapsible"
            onClick={() =>
              setIsDetailsSectionExpanded(!isDetailsSectionExpanded)
            }
          >
            DETAILS
            <span
              className={`payment__section-toggle ${
                isDetailsSectionExpanded ? "expanded" : ""
              }`}
            >
              {isDetailsSectionExpanded ? "▼" : "▶"}
            </span>
          </div>
          <div className="payment__order__summary">
            {isDetailsSectionExpanded && (
              <TelegramMiniMultiConfirmationForm
                fieldlabel_name={"Name"}
                fieldlabel_phone={"Phone No."}
                fieldlabel_address={"Postal Code"}
                fieldlabel_timeslot={"Timeslot"}
                fieldlabel_comments={"Comments"}
              />
            )}
          </div>
        </div>
      </div>
      <PaymentHandler buttonlabel={buttonText} onSubmit={onMainClick} />
      <Divider />
      {showManualPricingPopup && (
        <div className="payment-cost-popup">
          <div className="payment-cost-content">
            <PaymentForm
              // onSubmit={onMainClick}
              onChangeTotalCost={onChangeTotalCost}
              totalCostValue={manualPaymentCost}
              storeTotalCost={storeTotalCost}
              title={"Order Total"}
            />
          </div>
        </div>
      )}
    </TelegramScreen>
  );
};

export default SendMessageToServerCall;
